import React from "react";
import { useTranslation } from "react-i18next";

function View({
  supportHref,
  shareHref = "/actions/refresh?modal[type]=share",
}) {
  const { t } = useTranslation("athlete-portal");
  return (
    <div className={`Metrics-Foot${supportHref ? "" : " end"}`}>
      {supportHref && (
        <a className="support metric-anchor-foot" href={supportHref}>
          <div className="metric-anchor-container">
            <img src="/img/icons/help-icon.webp" alt="" />
            {t("metricsFoot.needHelp")}
          </div>
        </a>
      )}
    </div>
  );
}

export default View;
